// src/views/EducationView.js
import React, { useState } from 'react';
import { BookOpen } from 'lucide-react';
import glossaryTerms from '../glossary.json'; // Make sure this path points to your existing JSON file

export default function EducationView({ themeClasses }) {
  const [search, setSearch] = useState("");
  
  return (
    <div className="max-w-5xl mx-auto space-y-8 pb-12">
       <div>
         <h1 className={`text-3xl font-black ${themeClasses.textHead} mb-2`}>Education Center</h1>
         <p className={`text-sm ${themeClasses.textMuted} font-medium`}>Master the fundamentals of asset classes and portfolio management.</p>
       </div>
       
       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
         <div className={`${themeClasses.bgCard} p-6 rounded-3xl border ${themeClasses.border} shadow-xl`}>
            <h3 className="font-black text-indigo-500 uppercase text-xs tracking-widest mb-3">Stocks (Equities)</h3>
            <p className={`text-xs leading-relaxed ${themeClasses.textMain} mb-4`}>Represent ownership in a corporation. Offer the highest potential returns but carry the highest risk due to market volatility.</p>
            <p className={`text-[10px] font-bold ${themeClasses.textMuted} uppercase`}>Best Practice: Diversify across sectors.</p>
         </div>
         <div className={`${themeClasses.bgCard} p-6 rounded-3xl border ${themeClasses.border} shadow-xl`}>
            <h3 className="font-black text-emerald-500 uppercase text-xs tracking-widest mb-3">Bonds (Fixed Income)</h3>
            <p className={`text-xs leading-relaxed ${themeClasses.textMain} mb-4`}>Loans made to an entity. They pay a fixed interest rate over a set period until maturity. Lower risk, lower reward.</p>
            <p className={`text-[10px] font-bold ${themeClasses.textMuted} uppercase`}>Best Practice: Use to stabilize portfolios.</p>
         </div>
         <div className={`${themeClasses.bgCard} p-6 rounded-3xl border ${themeClasses.border} shadow-xl`}>
            <h3 className="font-black text-yellow-500 uppercase text-xs tracking-widest mb-3">ETFs & Funds</h3>
            <p className={`text-xs leading-relaxed ${themeClasses.textMain} mb-4`}>Baskets of securities traded on an exchange. Provides instant diversification within a specific market index or sector.</p>
            <p className={`text-[10px] font-bold ${themeClasses.textMuted} uppercase`}>Best Practice: Core foundation for growth.</p>
         </div>
       </div>
       
       <div className={`${themeClasses.bgCard} rounded-3xl border ${themeClasses.border} shadow-xl overflow-hidden flex flex-col h-[600px]`}>
          <div className={`p-6 border-b ${themeClasses.border} flex justify-between items-center shrink-0`}>
             <h3 className="font-black text-indigo-500 uppercase text-xs tracking-widest flex items-center"><BookOpen size={16} className="mr-2"/> Financial Glossary</h3>
             <input 
               value={search} 
               onChange={e => setSearch(e.target.value)} 
               placeholder="Search terms..." 
               className={`${themeClasses.input} border ${themeClasses.border} text-xs px-4 py-2 rounded-xl outline-none focus:border-indigo-500 ${themeClasses.textHead}`} 
             />
          </div>
          <div className="p-6 flex-1 overflow-y-auto custom-scrollbar grid grid-cols-1 md:grid-cols-2 gap-4">
             {glossaryTerms
               .filter(t => t.term.toLowerCase().includes(search.toLowerCase()) || t.definition.toLowerCase().includes(search.toLowerCase()))
               .map((t, i) => (
                <div key={i} className={`${themeClasses.input} p-4 rounded-2xl border ${themeClasses.border}`}>
                  <h4 className="text-indigo-500 font-black text-sm mb-1">{t.term}</h4>
                  <p className={`text-xs ${themeClasses.textMain} leading-relaxed`}>{t.definition}</p>
                </div>
             ))}
          </div>
       </div>
    </div>
  );
}